/*拦截器*/
import axios from 'axios'
import Vue from 'vue'
import {
  Message,
  LoadingBar
} from 'view-design'
import kmsVm from '@/main'

function getcookie(objname) {//获取指定名称的cookie的值
  var arrstr = document.cookie.split("; ");
  for (var i = 0; i < arrstr.length; i++) {
    var temp = arrstr[i].split("=");
    if (temp[0] == objname) return unescape(temp[1]);
  }
}
// Vue.prototype.$http = axios
Vue.prototype.$host = '/api'
Vue.prototype.$axios = axios

axios.defaults.withCredentials = true;
axios.defaults.baseURL = 'http://zkw-data-service:8085'
// axios.defaults.baseURL = 'http://192.168.1.105:8085'

axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';//配置请求头信息
// http://localhost:8888/index/queryMeun?token=bc0b747c4926954ff8a5a574aa8ecc17&_=1651736299905

if (process.env.NODE_ENV == 'production') {
  axios.defaults.baseURL = 'https://talent-api.zhongkewei.com';
  Vue.prototype.$host = 'https://talent-api.zhongkewei.com'
}
// 超时时间
axios.defaults.timeout = 30000
// http请求拦截器
let typeId = ''
axios.interceptors.request.use(config => {
  LoadingBar.start();
  if (config.url.indexOf('/video/getUrl') != -1) {
    typeId = config.params.typeId
  }
  config.headers['token'] = getcookie('kmsToken')
  // config.headers['Authorization'] = `${getcookie('kmsToken')}`
  return config
}, error => {
  LoadingBar.error();
  Message.error({
    message: '加载超时'
  })
  return Promise.reject(error)
})
// http响应拦截器
axios.interceptors.response.use(data => { // 响应成功关闭loading
  LoadingBar.finish();
  if (data.config.url.indexOf('/video/getUrl') != -1) {
    data.data.typeId = typeId
  }
  if (data.data.code != '0') {
    // Message.error({
    //   message: data.data.msg
    // })
    kmsVm.$toast(data.data.msg)
  }
  return data
}, error => {
  LoadingBar.error();
  Message.error({
    message: '加载失败'
  })
  return Promise.reject(error)
})
/*
 * 封装get方法
 * */
export function get(url, params = {}) {
  return new Promise((resolve, reject) => {
    console.log(params)
    axios.get(url, {
      params: params.params,
    })
      .then((response) => {
        resolve(response)

      })
      .catch((err) => {
        if (axios.isCancel(err)) {
          console.log('Request canceled', err.message);
        } else {
          // 处理错误
        }
        reject(err);
      });
  });
}
/*
 * 封装post方法
 * */
export function post(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.post(url, data)
      .then((response) => {
        resolve(response);
      })
      .catch((err) => {
        if (axios.isCancel(err)) {
          console.log('Request canceled', err.message);
        } else {
          console.log('qqda')
          // 处理错误
        }
        reject(err);
      });
  });
}



export default axios
